var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('div',{staticClass:"view__headline",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.title || _vm.record.title)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }